import { tv } from "@fanka/tailwind-variants";

export const HEADING_CLASS_NAME = tv({
  variants: {
    type: {
      h1: "text-head24",
      h2: "text-head20",
      h3: "text-head16",
    },
  },
});

export const BODY_CLASS_NAME = tv({
  variants: {
    size: {
      lg: "text-body16",
      md: "text-body14",
      sm: "text-body12",
    },
  },
});

export const UI_TEXT_CLASS_NAME = tv({
  variants: {
    size: {
      lg: "text-ui16",
      md: "text-ui14",
      sm: "text-ui12",
      xs: "text-ui10",
    },
    bold: {
      true: "font-bold",
    },
  },
});
